import { useGlobalState } from '../store'

const useStateSearch = () => {
  const [{ lawyerId, reason, keywordSelected }] = useGlobalState('searchLawyer')

  return { lawyerId, reason, keywordSelected }
}

export default useStateSearch
